// extracted by mini-css-extract-plugin
module.exports = {"title":"PerformersList_title__gNNQR","visuallyHidden":"PerformersList_visuallyHidden__IcVDq"};